import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_IMAGE_SLIDERS_LIST,
  FETCH_IMAGE_SLIDERS_LIST_ERROR,
  CLEAR_FETCH_IMAGE_SLIDERS_LIST,
  FETCH_IMAGE_SLIDER_DETAILS_SUCCESS,
  FETCH_IMAGE_SLIDER_DETAILS_ERROR,
  CLEAR_FETCH_IMAGE_SLIDER_DETAILS,
  APPLY_IMAGE_SLIDER_DRAG_SUCCESS,
  APPLY_IMAGE_SLIDER_DRAG_ERROR,
  CLEAR_IMAGE_SLIDER_DRAG,
  ADD_IMAGE_SLIDER_SUCCESS,
  ADD_IMAGE_SLIDER_ERROR,
  CLEAR_ADD_IMAGE_SLIDER,
  PATCH_IMAGE_SLIDER_SUCCESS,
  PATCH_IMAGE_SLIDER_ERROR,
  CLEAR_PATCH_IMAGE_SLIDER,
  DELETE_IMAGE_SLIDER_SUCCESS,
  DELETE_IMAGE_SLIDER_ERROR,
  CLEAR_DELETE_IMAGE_SLIDER,
  ADD_IMAGES_SUCCESS,
  ADD_IMAGES_ERROR,
  CLEAR_ADD_IMAGES,
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  CLEAR_DELETE_IMAGES,
  VERIFY_INSTAGRAM_ACCOUNT_SUCCESS,
  VERIFY_INSTAGRAM_ACCOUNT_ERROR,
  CLEAR_VERIFY_INSTAGRAM_ACCOUNT,
  PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS,
  PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR,
  CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER,
} from 'redux/image-sliders/types';

// FETCH
export const fetchImageSlidersList = () => baseErrorsHandlerDecorator(
  FETCH_IMAGE_SLIDERS_LIST,
  FETCH_IMAGE_SLIDERS_LIST_ERROR,
  () => restapi.get(addLang('links/sliders/')),
  false,
);

export const clearFetchImageSlidersList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_IMAGE_SLIDERS_LIST,
  });
};

// FETCH DETAILS
export const fetchImageSliderDetails = sliderId => baseErrorsHandlerDecorator(
  FETCH_IMAGE_SLIDER_DETAILS_SUCCESS,
  FETCH_IMAGE_SLIDER_DETAILS_ERROR,
  () => restapi.get(addLang(`links/sliders/${sliderId}/`)),
  false,
);

export const clearFetchImageSliderDetails = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_IMAGE_SLIDER_DETAILS,
  });
};

// DRAG
export const applyImageSliderDrag = formData => baseErrorsHandlerDecorator(
  APPLY_IMAGE_SLIDER_DRAG_SUCCESS,
  APPLY_IMAGE_SLIDER_DRAG_ERROR,
  () => restapi.post(addLang('links/sliders/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearImageSliderDrag = () => dispatch => {
  dispatch({
    type: CLEAR_IMAGE_SLIDER_DRAG,
  });
};

// ADD
export const addImageSlider = sliderType => baseErrorsHandlerDecorator(
  ADD_IMAGE_SLIDER_SUCCESS,
  ADD_IMAGE_SLIDER_ERROR,
  () => restapi.post(addLang('links/sliders/'), { slider_type: sliderType }),
  false,
  true /* actionSucces */,
);

export const clearAddImageSlider = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_IMAGE_SLIDER,
  });
};

// PATCH
export const patchImageSlider = (sliderId, formData) => baseErrorsHandlerDecorator(
  PATCH_IMAGE_SLIDER_SUCCESS,
  PATCH_IMAGE_SLIDER_ERROR,
  () => restapi.patch(addLang(`links/sliders/${sliderId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchImageSlider = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_IMAGE_SLIDER,
  });
};

// DELETE
export const deleteImageSlider = sliderId => baseErrorsHandlerDecorator(
  DELETE_IMAGE_SLIDER_SUCCESS,
  DELETE_IMAGE_SLIDER_ERROR,
  () => restapi.delete(addLang(`links/sliders/${sliderId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteImageSlider = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_IMAGE_SLIDER,
  });
};

// ADD IMAGES
export const addImagesToSlider = (sliderId, formData) => baseErrorsHandlerDecorator(
  ADD_IMAGES_SUCCESS,
  ADD_IMAGES_ERROR,
  () => restapi.post(addLang(`links/sliders/${sliderId}/media/`), formData),
  false,
  true /* actionSucces */,
);

export const clearAddImagesToSlider = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_IMAGES,
  });
};

// DELETE IMAGE
export const deleteImageFromSlider = imageId => baseErrorsHandlerDecorator(
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  () => restapi.delete(addLang(`links/sliders/media-details/${imageId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteImageFromSlider = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_IMAGES,
  });
};

// VERIFY INSTAGRAM ACCOUNT
export const verifyInstagramAccount = (sliderId, instagramUsername) => baseErrorsHandlerDecorator(
  VERIFY_INSTAGRAM_ACCOUNT_SUCCESS,
  VERIFY_INSTAGRAM_ACCOUNT_ERROR,
  () => restapi.post(
    addLang(`links/sliders/${sliderId}/verify-instagram/`),
    { instagram_username: instagramUsername },
  ),
  false,
  true /* actionSucces */,
);

export const clearVerifyInstagramAccount = () => dispatch => {
  dispatch({
    type: CLEAR_VERIFY_INSTAGRAM_ACCOUNT,
  });
};

// PATCH DETAILS FOR IMAGE SLIDER
export const patchDetailsForImageSlider = (imageId, formData) => baseErrorsHandlerDecorator(
  PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS,
  PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR,
  () => restapi.patch(addLang(`links/sliders/media-details/${imageId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchDetailsForImageSlider = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER,
  });
};
